import { render, staticRenderFns } from "./PreCotizacion.vue?vue&type=template&id=70f8fb7a&scoped=true&"
import script from "./PreCotizacion.vue?vue&type=script&lang=js&"
export * from "./PreCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./PreCotizacion.vue?vue&type=style&index=0&id=70f8fb7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8fb7a",
  null
  
)

export default component.exports